'use client';
import styled from 'styled-components';
import { Button as LmfButton } from '../Button';
import { FlagIconImage } from '../FlagIconImage';
export const Button = styled(LmfButton) `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${o => o.theme.spacing(4)};
  margin: 0px;
  padding: 0px ${o => o.theme.spacing(4)};
`;
export const TextSpan = styled.span `
  margin: ${o => o.theme.spacing(2)} 0px;
  color: ${o => o.theme.color.text.primary.on.background};
`;
export const LocaleButtonFlagIconImage = styled(FlagIconImage) `
  height: ${o => o.theme.spacing(6)};
  width: ${o => o.theme.spacing(6)};
`;
//# sourceMappingURL=styles.js.map